const cleanTsReducer = (state = "", action) => {
    switch (action.type) {
        case "setCleanTs":
            return action.payload;
        default:
            return state;
    }
};

export default cleanTsReducer;
